<template>
   <div class="bi-main">
        <div class="bi-list"  v-if="!isShowModelFormList">
            <div class="bi-item" v-for="(item,index) in reportList" :key="index" @click="showDetail(item.formId)">
                <div class="bi-item-left">
                    <i class="iconfont icon-other-bi"></i>
                </div>
                <div class="bi-item-right">
                    {{item.name}}
                </div>
            </div>
        </div>
        <div class="bi-detail" v-if="isShowModelFormList">
            <div class="back-btn">
                <el-button @click="changeBiPattern">返回</el-button>
            </div>
            <DashBoard
                :key="loadTimer"
                ref="dashBoardRefs"
                :chartType="chartType"
                :chartData="chartData"
                :chartSettings="chartSettings"
                :selectedModel="selectedModel"
                :isNewPage="isNewPage"
                :showLeft="showLeft"
                :conditionFields="conditionFields"
                :biConditionFields="biConditionFields"
                @getBiData="getBiData"
                :showSearch="true"
                @showSearch="showSearch"
                :showLeftSwitch="true"
                @swtitcList="swtitcList"
                :showBiWay="showBiWay"
                :isShowModelFormList="isShowModelForm"
                @refreshSearchConditon="refreshSearchConditon"
            />
        </div>
        <!-- 侧滑弹窗 -->
        <el-drawer
          :visible.sync="active"
          title="搜索查询"
          :direction="direction"
          size="25vw"
            >
          <SearchConditionSide
              ref="searchConditon"
              :key="searchLoadTimer"
              :conditionFields="conditionFields"
              :biConditionFields="biConditionFields"
              @searchForList="searchForList"
              @resetSearchConditon="resetSearchConditon"
          />
        </el-drawer>
   </div>
</template>

<script>
    import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
    import DashBoard from '@/components/DashBoard';
    import {getApplicationModelMenuList, getFormFieldListByIds, getFormDashBoardData} from '@/data-model';
    export default {
        components: {
            DashBoard,
            SearchConditionSide
        },
        data () {
            return {
                reportList: [],
                loadTimer: '',
                searchLoadTimer: '',
                selectedModel: {},
                formBtnAuth: {
                    // 表单按钮权限
                    type: Object,
                    default: function () {
                        return {
                            isShowView: true, // 查看
                            isShowAdd: false, // 新增
                            isShowEdit: false, // 修改
                            isShowDelete: true, // 删除
                            isShowImport: true, // 导入
                            isShowExport: true, // 导出
                            isShowSyn: true, // 同步流程数据
                            isShowConfig: false // 进入应用配置
                        };
                    }
                },
                isShowModelFormList: false,
                chartType: 1,
                chartSettings: {},
                chartData: {},
                BiSearchCondition: {
                    formId: '',
                    searchCondition: []
                },
                isShowModelForm: 0,
                active: false,
                conditionFields: [],
                biConditionFields: [],
                direction: 'ltr'
            };
        },
        props: {
            appId: {
                type: Number,
                default: 0
            },
            isNewPage: {
                type: Boolean,
                default: false
            },
            showLeft: {
                type: Boolean,
                default: false
            }
        },
        created () {
            // this.initReportData();
        },
        methods: {
            async initReportData () {
                let appSystemlList = [];
                let reportList = [];
                if (this.appId === 0) {
                    appSystemlList = await getApplicationModelMenuList();
                } else {
                    appSystemlList = await getApplicationModelMenuList({ appId: this.appId });
                }
                if (appSystemlList && appSystemlList.length > 0) {
                    for (let i = 0; i < appSystemlList.length; i++) {
                        let curObj = appSystemlList[i];
                        let subModel = curObj.subModel;
                        let children = curObj.children;
                        if (subModel && subModel.length > 0) { // 如果存在直属子节点则取出来
                            for (let i = 0; i < subModel.length; i++) {
                                let subModelObj = subModel[i];
                                if (subModelObj.modelType === 3) { // 这是BI
                                    reportList.push(subModelObj);
                                }
                            }
                        }
                        if (children && children.length > 0) { // 如果子集则继续便利
                            for (let i = 0; i < children.length; i++) {
                                let childrenObj = children[i];
                                let subModel = childrenObj.subModel;
                                if (subModel && subModel.length > 0) { // 如果存在直属子节点则取出来
                                    for (let i = 0; i < subModel[i].length; i++) {
                                        let subModelObj = subModel[i];
                                        if (subModelObj.modelType === 3) { // 这是BI
                                            reportList.push(subModelObj);
                                        }
                                    }
                                }
                                let childrenList = childrenObj.children;
                                if (childrenList && childrenList.length > 0) {
                                    for (let i = 0; i < childrenList.length; i++) {
                                        let obj = childrenList[i];
                                        if (obj.modelType === 3) {
                                            reportList.push(obj);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.reportList = reportList;
                    if (this.reportList.length < 1) {
                        this.$message({
                            message: '暂无数据',
                            type: 'warning',
                            duration: 2000
                        });
                    }
                } else {
                    this.reportList = [];
                    this.$message({
                        message: '没有查询到数据',
                        type: 'warning',
                        duration: 2000
                    });
                }
            },
            async showDetail (id) {
                this.isShowdApproveModel = false;
                this.BiSearchCondition.formId = id;
                this.getBiData(null, true);
            },
            async refreshSearchConditon (columns) {
                this.conditionFields.length = 0;
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                let cfs = await getFormFieldListByIds(idArr.join(','));
                this.conditionFields = [];
                if (cfs && cfs.length > 0) {
                    for (var i = 0; i < cfs.length; i++) {
                        if (cfs[i].type === 'subform') {
                            continue;
                        } else {
                            this.conditionFields.push(cfs[i]);
                        }
                    }
                }
                this.searchLoadTimer = new Date().getTime();
            },
            swtitcList () {
                this.isShowModelFormList = false;
            },
            async getBiData (searchCondition, isInitSearch) {
                this.BiSearchCondition.searchCondition = searchCondition;
                // 2.列表/报表
                const loading = this.$loading({
                    lock: true,
                    text: 'Loading',
                    spinner: 'el-icon-loading',
                    background: 'rgba(0, 0, 0, 0.7)'
                });
                let obj = await getFormDashBoardData(this.BiSearchCondition);
                if (obj.conditionFields != null) {
                    this.biConditionFields = JSON.parse(obj.conditionFields);
                }
                this.chartType = obj.chartType;
                this.chartSettings = obj.chartSettings;
                this.chartData = obj.chartData;
                this.selectedModel.dataModelId = obj.dataModelId;
                this.selectedModel.dataFormId = obj.dataFormId;
                this.isShowBi = true;
                this.isShowModelForm = obj.showDataSource;
                this.showBiWay = obj.showBiWay;
                this.isShowModelFormList = true;
                setTimeout(() => {
                    // 调用子组件的方法
                    if (this.$refs.dashBoardRefs) {
                        this.$refs.dashBoardRefs.renderFormList(this.selectedModel, isInitSearch, searchCondition);
                    }
                }, 0);
                loading.close();
            },
            searchForList () {
                this.$refs.dashBoardRefs.renderFormList(this.selectedModel, false, this.conditionFields);
            },
            async resetSearchConditon () {
                await this.$refs.dashBoardRefs.renderFormList(this.selectedModel, true, []);
            },
            showSearch () {
                this.active = true;
            },
            changeBiPattern () {
                this.isShowModelFormList = false;
            }
        }
    };
</script>

<style lang="less" scoped="scoped">
.bi-main{
    height: 85vh;
    width: 100%;
    overflow-y: overlay;
    .bi-list{
        display: flex;
        flex-wrap:wrap;
        .bi-item{
            height: 80px;
            display: flex;
            width: auto;
            text-align: left;
            line-height: 80px;
            cursor: pointer;
            margin-left: 1vw;
            margin-top: 10px;
            border: 1px solid #e1e6ec;
            border-radius: 6px;
            color: #615858;
            .bi-item-left{
                width: 50px;
                height: 80px;
                line-height: 90px;
                text-align: center;
                padding-left: 1vw;
                .icon-other-bi{
                    font-size: 2rem;
                }
            }
            .bi-item-right{
                font-size: 1.75rem;
                height: 80px;
                line-height: 80px;
                padding-right: 1vw;
            }
        }
        .bi-item:hover{
            border: 1px solid #7dcef3;
        }
   }
   .bi-detail{
       height: 100%;
       .back-btn{
           position: absolute;
           z-index: 999;
       }
       .BI-content{
          position: relative;
          width: 100%;
          height: ~"calc(100% - 30px)";
          /deep/ .BI-area{
              position: relative;
              width: 100%;
              height: 100%;
              text-align: center;
              .BI-area-one{
                  position: relative;
                  height: 100%;
                  .ve-histogram{
                     height: ~"calc(100% + 30px)" !important;
                  }
              }
              .is-justify-end{
                  margin-top: -12px;
              }
          }
          /deep/ .summary-count{
            display: flex;
            position: absolute;
            width: 600px;
            height: auto;
            left: 50px;
            .summary-count-item{
                display: flex;
                margin-left: 20px;
                flex: 1;
                .summary-count-item-lable{
                    color: #333;
                }
                .summary-count-item-count{
                    margin-left: 10px;
                    color: #1592cc;
                }
            }
          }
       }
   }
}
</style>



// WEBPACK FOOTER //
// src/components/ApplicationBi/ApplicationBi.vue